export default __webpack_public_path__ + "3e3f3329ad5ba72ca1253af1c64fd7cb.png";